export default __webpack_public_path__ + "static/media/what-you-get-mob.11ca072e.png";